import type { BatteryProposalDto } from "~/api/dto/battery-proposal.dto"

import type { BatterySetupStep } from "./setup-steps"

export type BatteryPricingSetupGapId =
  | `battery-and-quantity`
  | `finance-plan`
  | `powur-project`
  | `property-address`
  | `requested-fixed-margin`
  | `utility-company`

export type BatteryPricingSetupGap = {
  readonly id: BatteryPricingSetupGapId
  readonly label: string
  readonly step: BatterySetupStep | null
}

const isFilled = (value: string): boolean => value.trim() !== ``

export const batteryPricingSetupGaps = (
  proposal: BatteryProposalDto,
): BatteryPricingSetupGap[] => {
  const gaps: BatteryPricingSetupGap[] = []
  const { address, equipment, financePlan, tariff } = proposal

  if (proposal.powurProjectId == null) {
    gaps.push({
      id: `powur-project`,
      label: `Powur Project`,
      step: null,
    })
  }

  if (
    !isFilled(address.street) ||
    !isFilled(address.city) ||
    !isFilled(address.state) ||
    !isFilled(address.postal)
  ) {
    gaps.push({
      id: `property-address`,
      label: `property address`,
      step: null,
    })
  }

  if (tariff?.lseId == null) {
    gaps.push({
      id: `utility-company`,
      label: `Utility Company`,
      step: `utility`,
    })
  }

  if (equipment == null || equipment.quantity < 1) {
    gaps.push({
      id: `battery-and-quantity`,
      label: `Battery and quantity`,
      step: `equipment`,
    })
  }

  if (financePlan == null) {
    gaps.push({
      id: `finance-plan`,
      label: `Finance Plan`,
      step: `equipment`,
    })
  }

  if (!Number.isFinite(proposal.requestedFixedMargin)) {
    gaps.push({
      id: `requested-fixed-margin`,
      label: `Requested Fixed Margin`,
      step: null,
    })
  }

  return gaps
}

export const isBatteryPricingSetupComplete = (
  proposal: BatteryProposalDto | undefined,
): boolean => proposal != null && batteryPricingSetupGaps(proposal).length === 0
